<template>
    <header
        ref="floatHeader"
        class="float-header"
    >
        <transition name="fade">
            <div
                v-if="!hidden"
                class="container container_mob-no-p"
            >
                <div class="float-header__card-glass _pa-8 white-text _dflex _align-items-center">
                    <HeaderLogo :dark="dark" />
                    <ul class="_dflex _mobile-hidden-flx _gap-24">
                        <li
                            v-for="item in menuItems"
                            :key="item.id"
                        >
                            <a
                                v-if="item.href.startsWith('#')"
                                :href="item.href"
                                v-js-anchor
                            >{{ item.title }}</a>
                            <a
                                v-else
                                :href="item.href"
                                :target="item.newWindow ? '_blank' : '_self'"
                            >{{ item.title }}</a>
                        </li>
                    </ul>
                    <div class="_flex-1" />
                    <slot name="cta" />
                    <button
                        v-if="$scopedSlots['modal-callback']"
                        class="_ml-16 button button_gray-seventh button_size-md button_size-md_icon button_width-fit"
                        @click="onClickPhone"
                    >
                        <div class="icon icon-phone_white icon_size-16 _mr-0" style="display: block!important;" />
                    </button>
                </div>
            </div>
        </transition>
        <slot name="modal-callback" :isShowedPhoneModal="isShowedPhoneModal" :setIsShowedPhoneModal="(val) => isShowedPhoneModal = val" />
    </header>
</template>
<script>
import { useStore } from '../../store';
import { computed, ref, watch } from 'vue';
import { useResizeObserver } from '../../assets/js/vue/utlis/useResizeObserver';
import fastdom from 'fastdom';
import HeaderLogo from '../../components/header/HeaderLogo.vue';

export default {
    name: 'FloatHeader',
    props: {
        menuItems: {
            type: Array,
            default: () => [],
        },
        dark: Boolean,
    },
    componetns: {
        HeaderLogo,
    },
    setup() {
        const store = useStore();

        const scrollTop = computed(() => store.state.app.scrollY);
        const headerIsSticky = computed(() => store.state.app.headerIsSticky);

        const floatHeader = ref(null);

        const headerHeight = ref(0);
        const headerTop = ref(0);

        const hidden = computed(() => !headerIsSticky.value);

        const getHeight = ([entry]) => {
            fastdom.measure(() => {
                const { height, top } = entry.target.getBoundingClientRect();
                headerHeight.value = height;
                headerTop.value = top;
            });
        }

        useResizeObserver(floatHeader, getHeight, { box: 'border-box' });

        watch([headerHeight, hidden, headerTop], ([headerHeight, hidden, headerTop]) => {
            if (hidden) return;

            store.commit('app/SET_HEADER_FLOAT_HEIGHT', headerHeight);
            store.commit('app/SET_HEADER_FLOAT_TOP', headerTop);
        }, { immediate: true });

        return {
            scrollTop,
            hidden,
            floatHeader,
        };
    },
    data() {
        return {
            isShowedPhoneModal: false,
        };
    },
    methods: {
        onClickPhone() {
            this.isShowedPhoneModal = true;
        },
    },
}
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/functions';
@import '../../assets/scss/base/mixins';

.float-header {
    position: fixed;
    left: 0;
    width: 100%;
    z-index: 2;
    @include fluid('top', 16px, 0px);

    &__card-glass {
        @include fluid('border-radius', 16px, 0px);
        @include fluid('--blur', 16px);
        background: rgba($white-101, .24);
        backdrop-filter: blur(var(--blur));
    }

    &__cb-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        user-select: none;
        pointer-events: none;
        z-index: -1;

        &::before {
            @include fluid('--blur', 16px);
            content: "";
            display: block;
            width: 100%;
            height: 100%;
            filter: blur(var(--blur));
            @include fluid('--float-header-cb-bg-t', -880px, -100px);
            @include fluid('--float-header-cb-bg-h', 1360px, 240px);
            background: center var(--float-header-cb-bg-t) / 120% var(--float-header-cb-bg-h) no-repeat radial-gradient(100% 80% at 50% 50%, #41deff7a 23%, #00B6ADaa 35%, #07B5A800 55%);
            @include mobile {
                display: none;
            }
            transform: scale(1.05);
        }
    }
}
</style>
